import type { App } from 'vue'
import type { IAuth, IAuthOptions } from '@clickadilla/components/plugins'
import handleErrors from '@/services/handleErrors'
import http from '@/services/http'
import { personalRepository } from '@/services/repository-factory'
import { useAuth } from '@/services/use-auth'
import settings from '@/settings'
import type { AuthUser } from '@/types/auth'

export const authOptions: IAuthOptions<AuthUser> = {
  repository: {
    login: (data: unknown) => personalRepository.login(data),
    refresh: () => personalRepository.refresh(),
    profile: () => personalRepository.profile2()
  },
  tokenKey: settings.authTokenKey,
  onError: (error: unknown) => handleErrors(error as object)
}

export function registerAuthInterceptors(app: App): void {
  let auth: IAuth<AuthUser> | null = null
  const resolveAuth = () => (auth ??= app.runWithContext(() => useAuth()))

  http.interceptors.request.use((config) => {
    const token = resolveAuth().getToken()
    if (token) {
      config.headers.set('Authorization', `Bearer ${token}`)
    }
    return config
  })

  http.interceptors.response.use(undefined, (error) => {
    if (error.response?.status === 401) {
      resolveAuth().removeToken()
    }
    return Promise.reject(error)
  })
}
